import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer, PageResDo } from 'src/types/base';

export declare namespace ApplicationMarketDOI{
    export interface RowDataI {
        id: number;
        file_name: string;
        data_url: string;
        file_version:string;
        file_describe:string;
        type:number;
    }

    export interface QueryRowDataParamsI extends PageDo {
        type?: number;
    }

    export interface AddData {
        id?: number;
        file_name: string;
        file_version: string;
        data_url: string;
        file_describe: string;
        type:number;
    }
}


export default class ApplicationMarketApi {
    /**
     * 查询上位机资料
     * @param {ApplicationMarketDOI.QueryRowDataParamsI} params 
     * @returns 
     */
    static async userQueryList(params: ApplicationMarketDOI.QueryRowDataParamsI):Promise<Result<ApplicationMarketDOI.RowDataI[]>>{
        return Api.post('/management/query/upper_computer/data', {
            type: -2,
            ...params,
        });
    }
    

    /**
     * 新增上位机资料
     * @param params 
     */
    static async add(params: ApplicationMarketDOI.AddData):Promise<Result<any>>{
       return Api.post('/management/add/upper_computer/data', params)
    }

    /**
     * 
     * @param id 删除上位机资料
     */
    static async delete(id: number): Promise<Result<any>>{
        return Api.post('/management/delete/upper_computer/data', {id: id})
    }
}